import { ChangeDetectionStrategy, Component } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { ActiveModal } from '@frontend/sports/modal/feature';
import { Page } from '@frontend/vanilla/core';
import { Store } from '@ngrx/store';
import { Observable, map, switchMap } from 'rxjs';

import { IBetslipRootState } from '../../../../base/store/state';
import { BetslipErrorMessageFormatterService } from '../../../validation/services/formatting/betslip-error-message-formatter.service';
import { betPlacedResultSelector } from '../../quick-bet.selectors';

@Component({
    selector: 'bs-quick-bet-place-bet-error-modal',
    templateUrl: './quick-bet-place-bet-error-modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./quick-bet-place-bet-error-modal.component.scss'],
    standalone: false,
})
export class QuickBetPlaceBetErrorModalComponent {
    messages$: Observable<string[]>;

    constructor(
        public sitecore: Sitecore,
        public pageConfig: Page,
        private activeModal: ActiveModal,
        store: Store<IBetslipRootState>,
        private errorFormatter: BetslipErrorMessageFormatterService,
    ) {
        this.messages$ = store.select(betPlacedResultSelector).pipe(
            map((t) => t.errors),
            switchMap((errors) => this.errorFormatter.getErrorsMessages(errors)),
        );
    }

    close = (): void => this.activeModal.close();
}
